import React from "react";
import styles from "./index.module.css";

const ForgetBanner = (props) => {
  return (
    <div className={styles["container"]}>
      {/* Banner */}
      <div className={styles["left"]}>
        <div className={styles["card"]}>
          <div className={styles["top"]}>
            <img src={"./logo_green.png"} alt="priceport green logo" />
          </div>
          <div className={styles["bottom"]}>
            <div className={styles["content"]}>
              <div className={styles["text"]}>Generate, New Password</div>
              <div className={styles["illustration"]}>
                <img
                  src={"./illustration_fp.png"}
                  alt="illustration of girl walking with system"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Forgot passowrd inputs. */}
      <div className={styles["right"]}>{props.children}</div>
    </div>
  );
};

export default ForgetBanner;
